const translations = {
    es: {
        process_monitor: "Monitor de Procesos",
        recovery: "Recuperación",
        recovery_sigfox: "Recuperación Sigfox",
        total_devices: "Total Dispositivos",
        processed_devices: "Dispositivos Procesados",
        processed: "Procesados",
        errors: "Errores",
        with_Messages: "Con Mensajes",
        without_Messages: "Sin Mensajes",
        alreadyExists: "Ya Existían",
        progress_devices: "Progreso de Dispositivos",
        progress_messages: "Mensajes Recuperados",
        recovery_log: "Registro del Proceso de Recuperación",
        de: "de",
        in_progress: "En Progreso",
        finished: "Finalizado",
        loading: "Cargando...",
    },
    en: {
        process_monitor: "Process Monitor",
        recovery: "Recovery",
        recovery_sigfox: "Sigfox Recovery",
        total_devices: "Total Devices",
        processed_devices: "Processed Devices",
        errors: "Errors",
        with_Messages: "With Messages",
        without_Messages: "Without Messages",
        alreadyExists: "Already Exists",
        progress_devices: "Device Progress",
        progress_messages: "Recovered Messages",
        recovery_log: "Recovery Process Log",
        de: "of",
        in_progress: "In Progress",
        finished: "Finished",
        loading: "Loading...",
    },
};

export default translations;
